import { Route, Routes } from 'react-router-dom';
import LandingPage from '@features/workspace/views/landing';
import Company from '@features/workspace/views/company';
import Documents from '@features/workspace/views/document';
import CreditPage from '@features/workspace/views/credit';
import Banking from '@features/workspace/views/banking';
import NotFoundPage from '@features/workspace/views/not-found';

const CustomerRouter = () => {
  return (
    <Routes>
      <Route element={<LandingPage />} path="/" />
      <Route element={<Company />} path="/company/*" />
      <Route element={<Documents />} path="/documents" />
      <Route element={<Banking />} path="/banking/*" />
      <Route element={<CreditPage />} path="/credit" />
      <Route element={<NotFoundPage />} path="*" />
    </Routes>
  );
};

export default CustomerRouter;
